import React from 'react'

function Subestacion2(props) {

    const { svgData, data } = props;

    //seccionadores
    var secc89PTL, secc89L, secc89H05, secc57H05A, secc57H05B, secc57H06, secc89H06, secc89H07, secc57H07
    var secc89PTLcolor, secc89Lcolor, secc89H05color, secc57H05Acolor, secc57H05Bcolor, secc57H06color, secc89H06color, secc89H07color, secc57H07color

    //reles
    var H0650BF, PT_T2_UCP_IDF50BF, PT_T2_UCP_IDF86

    //interruptores
    var inte52HTB, inteH06, inteH07
    var inte52HTBcolor, inteH06color, inteH07color
    var estado52HTB, estadointeH06 = "?", estadointeH07 = "?"

    if (svgData.length > 0) {
        for (let i = 0; i < svgData.length; i++) {

            if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89PTL-B") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89PTL = "m97.993 39.952 1.159.985"
                        secc89PTLcolor = "#33BBC2"
                        break;
                    case "indeterminado":
                        secc89PTL = "m97.993 39.952 1.159.985"
                        secc89PTLcolor = "#000000"
                        break;
                    case "desconocido":
                        secc89PTL = "m97.993 39.952 1.159.985"
                        secc89PTLcolor = "#ff0000"
                        break;
                    case "cerrado":
                        secc89PTL = "m97.462 41.217 1.521 -.005"
                        secc89PTLcolor = "#33BBC2"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89L-HTB") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89L = "m97.113 44.169-.841 1.225"
                        secc89Lcolor = "#33BBC2"
                        break;
                    case "indeterminado":
                        secc89L = "m97.113 44.169-.841 1.225"
                        secc89Lcolor = "#000000"
                        break;
                    case "desconocido":
                        secc89L = "m97.113 44.169-.841 1.225"
                        secc89Lcolor = "#ff0000"
                        break;
                    case "cerrado":
                        secc89L = "m96.057 43.784-.004 1.486"
                        secc89Lcolor = "#33BBC2"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "57T2" && svgData[i].posicion === "H05") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc57H05A = "m84.402 75.737 1.264.846"
                        secc57H05B = "m84.28 81.133 1.24.883"
                        secc57H05Acolor = "#c1c134"
                        secc57H05Bcolor = "#c1c134"
                        break;
                    case "indeterminado":
                        secc57H05A = "m84.402 75.737 1.264.846"
                        secc57H05B = "m84.28 81.133 1.24.883"
                        secc57H05Acolor = "#000000"
                        secc57H05Bcolor = "#000000"
                        break;
                    case "desconocido":
                        secc57H05A = "m84.402 75.737 1.264.846"
                        secc57H05B = "m84.28 81.133 1.24.883"
                        secc57H05Acolor = "#ff0000"
                        secc57H05Bcolor = "#ff0000"
                        break;
                    case "cerrado":
                        secc57H05A = "m84.007 76.803 1.522-.006"
                        secc57H05B = "m83.918 82.254 1.52-.002"
                        secc57H05Acolor = "#c1c134"
                        secc57H05Bcolor = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89T2" && svgData[i].posicion === "H05") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89H05 = "m83.633 74.398-.749 1.016"
                        secc89H05color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc89H05 = "m83.633 74.398-.749 1.016"
                        secc89H05color = "#000000"
                        break;
                    case "desconocido":
                        secc89H05 = "m83.633 74.398-.749 1.016"
                        secc89H05color = "#ff0000"
                        break;
                    case "cerrado":
                        secc89H05 = "m82.635 74.067-.005 1.263"
                        secc89H05color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "57" && svgData[i].posicion === "CELDA H06 TRAFO 2") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc57H06 = "m97.835 59.175 1.239.883"
                        secc57H06color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc57H06 = "m97.835 59.175 1.239.883"
                        secc57H06color = "#000000"
                        break;
                    case "desconocido":
                        secc57H06 = "m97.835 59.175 1.239.883"
                        secc57H06color = "#ff0000"
                        break;
                    case "cerrado":
                        secc57H06 = "m97.447 60.306h1.521"
                        secc57H06color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89" && svgData[i].posicion === "CELDA H06 TRAFO 2") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89H06 = "m97.146 63.233-.877 1.434"
                        secc89H06color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc89H06 = "m97.146 63.233-.877 1.434"
                        secc89H06color = "#000000"
                        break;
                    case "desconocido":
                        secc89H06 = "m97.146 63.233-.877 1.434"
                        secc89H06color = "#ff0000"
                        break;
                    case "cerrado":
                        secc89H06 = "m96.072 62.9-.01 1.682"
                        secc89H06color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "57" && svgData[i].posicion === "CELDA H07 LINEA 3") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc57H07 = "m104.854 80.857 1.192.945"
                        secc57H07color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc57H07 = "m104.854 80.857 1.192.945"
                        secc57H07color = "#000000"
                        break;
                    case "desconocido":
                        secc57H07 = "m104.854 80.857 1.192.945"
                        secc57H07color = "#ff0000"
                        break;
                    case "cerrado":
                        secc57H07 = "m104.361 82.01 1.521.007"
                        secc57H07color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89" && svgData[i].posicion === "CELDA H07 LINEA 3") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89H07 = "m103.952 78.393-.696 1.054"
                        secc89H07color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc89H07 = "m103.952 78.393-.696 1.054"
                        secc89H07color = "#000000"
                        break;
                    case "desconocido":
                        secc89H07 = "m103.952 78.393-.696 1.054"
                        secc89H07color = "#ff0000"
                        break;
                    case "cerrado":
                        secc89H07 = "m103.01 78.072.002 1.262"
                        secc89H07color = "#c1c134"
                        break;
                }
            }  else if (svgData[i].dispositivo === "rele" && svgData[i].posicion === "CELDA H06 TRAFO 2"){
                switch(svgData[i].estado){
                    case "normal":
                        H0650BF = "none"
                        break;
                    case "disparado":
                        H0650BF = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "rele" && svgData[i].posicion === "PT_T2_UCP_IDF" && svgData[i].nombre === "50BF"){
                switch(svgData[i].estado){
                    case "normal":
                        PT_T2_UCP_IDF50BF = "none"
                        break;
                    case "disparado":
                        PT_T2_UCP_IDF50BF = "#33BBC2"
                        break;
                }
            } else if (svgData[i].dispositivo === "rele" && svgData[i].posicion === "PT_T2_UCP_IDF" && svgData[i].nombre === "86"){
                switch(svgData[i].estado){
                    case "normal":
                        PT_T2_UCP_IDF86 = "none"
                        break;
                    case "disparado":
                        PT_T2_UCP_IDF86 = "#33BBC2"
                        break;
                }
            } else if (svgData[i].dispositivo === "interruptor" && svgData[i].posicion === "PT_T2_UCP_IDF") {
                switch (svgData[i].estado) {
                    case "abierto":
                        inte52HTB = "url(#cuadradoAzul2)"
                        inte52HTBcolor = "#fff"
                        break;
                    case "indeterminado":
                        inte52HTB = "url(#cruzAzul2)"
                        inte52HTBcolor = "#33BBC2"
                        break;
                    case "desconocido":
                        inte52HTB = "url(#cruzAzul2)"
                        inte52HTBcolor = "#33BBC2"
                        break;
                    case "cerrado":
                        inte52HTB = "url(#cuadradoAzul2)"
                        inte52HTBcolor = "#33BBC2"
                        break;
                }
                if(svgData[i].conexion === "remoto"){
                    estado52HTB = "none"
                    estadointeH06 = "R"
                    estadointeH07 = "R"
                } else if (svgData[i].conexion === "local"){
                    estado52HTB = "#33BBC2"
                    estadointeH06 = "L"
                    estadointeH07 = "L"
                }
            } else if(svgData[i].dispositivo === "interruptor" && svgData[i].posicion === "CELDA H06 TRAFO 2"){
                switch(svgData[i].estado){
                    case "abierto":
                        inteH06 = "url(#cuadradoAmarilloH06)"
                        inteH06color = "#fff"
                        break;
                    case "indeterminado":
                        inteH06 = "url(#cruzAmarillaH06)"
                        inteH06color = "#c1c134"
                        break;
                    case "desconocido":
                        inteH06 = "url(#cruzAmarillaH06)"
                        inteH06color = "#c1c134"
                        break;
                    case "cerrado":
                        inteH06 = "url(#cuadradoAmarilloH06)"
                        inteH06color = "#c1c134"
                        break;
                }
            } else if(svgData[i].dispositivo === "interruptor" && svgData[i].posicion === "H07 L3"){
                switch(svgData[i].estado){
                    case "abierto":
                        inteH07 = "url(#cuadradoAmarilloH07)"
                        inteH07color = "#fff"
                        break;
                    case "indeterminado":
                        inteH07 = "url(#cruzAmarillaH07)"
                        inteH07color = "#c1c134"
                        break;
                    case "desconocido":
                        inteH07 = "url(#cruzAmarillaH07)"
                        inteH07color = "#c1c134"
                        break;
                    case "cerrado":
                        inteH07 = "url(#cuadradoAmarilloH07)"
                        inteH07color = "#c1c134"
                        break;
                }
            }
            
        }
    }

    var B01 = -1, B02 = -1, B03 = -1, B04 = -1, B05 = -1, B06 = -1, B07 = -1, B08 = -1, B09 = -1, toma = -1

    if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {

            switch (data[i].posicion) {
                case "IDF TRAFO 2":
                    B01 = data[i].Vab
                    B02 = data[i].Ia
                    B03 = data[i].P
                    B04 = data[i].Q
                    if(data[i].toma !== null) { toma = data[i].toma }
                    break;
                case "CELDA H06 TRAFO 2":
                    B05 = data[i].Ia
                    B06 = data[i].P
                    B07 = data[i].Q
                    B08 = data[i].Vab
                    break;
                case "CELDA H07 LINEA 3":
                    B09 = data[i].Ia
                    break;
                }
        }

    }

    return (
        <svg
            width="170mm"
            height="237mm"
            viewBox="88 33 15 57"
            version="1.1"
            id="svg6"
            xmlns="http://www.w3.org/2000/svg">
            <defs>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="circuloAzul2"
                    refX={2}
                    refY={0}
                    orient="auto"
                    markerWidth={2.4}
                    markerHeight={2.4}
                    viewBox="0 0 5.4 5.4"
                    preserveAspectRatio="xMidYMid"
                    stroke="#33BBC2"
                    fill="none"
                >
                    <path
                        transform="scale(.45)"
                        style={{
                            fill: "context-fill",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: 2,
                        }}
                        d="M5 0c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.3-5 5-5c2.76 0 5 2.24 5 5z"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="circuloAmarillo2"
                    refX={2}
                    refY={0}
                    orient="auto"
                    markerWidth={2.4}
                    markerHeight={2.4}
                    viewBox="0 0 5.4 5.4"
                    preserveAspectRatio="xMidYMid"
                    stroke="#C1C134"
                    fill="none"
                >
                    <path
                        transform="scale(.45)"
                        style={{
                            fill: "context-fill",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: 2,
                        }}
                        d="M5 0c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.3-5 5-5c2.76 0 5 2.24 5 5z"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="flechaAzul2"
                    refX={0}
                    refY={0}
                    orient="auto-start-reverse"
                    markerWidth={2.135}
                    markerHeight={2.064}
                    viewBox="0 0 6.135 5.93"
                    preserveAspectRatio="xMidYMid"
                    stroke="#33BBC2"
                    fill="#33BBC2"
                >
                    <path
                        transform="scale(.7)"
                        d="M-.211-4.106 6.21-.894a1 1 90 0 1 0 1.788L-.21 4.106A1.236 1.236 31.717 0 1-2 3v-6A1.236 1.236 148.283 0 1-.211-4.106z"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "none",
                        }}
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="flechaAmarilla2"
                    refX={0}
                    refY={0}
                    orient="auto-start-reverse"
                    markerWidth={2.135}
                    markerHeight={2.064}
                    viewBox="0 0 6.135 5.93"
                    preserveAspectRatio="xMidYMid"
                    stroke="#C1C134"
                    fill="#C1C134"
                >
                    <path
                        transform="scale(.7)"
                        d="M-.211-4.106 6.21-.894a1 1 90 0 1 0 1.788L-.21 4.106A1.236 1.236 31.717 0 1-2 3v-6A1.236 1.236 148.283 0 1-.211-4.106z"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "none",
                        }}
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cuadradoAmarillo2"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill="#C1C134"
                    stroke="#C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cuadradoAmarilloH06"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH06color}
                    stroke="#C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cuadradoAmarilloH07"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH07color}
                    stroke="#C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cruzAmarillaH06"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH06color}
                    stroke="C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="m-3.5 4.5 9-9m0 9-9-9"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cruzAmarillaH07"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH07color}
                    stroke="C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="m-3.5 4.5 9-9m0 9-9-9"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="barraAzul2"
                    refX={0}
                    refY={0}
                    orient="auto"
                    markerWidth={0.41}
                    markerHeight={3}
                    viewBox="0 0 1 8"
                    preserveAspectRatio="none"
                    fill="#33BBC2"
                    stroke="#33BBC2"
                >
                    <path
                        style={{
                            fill: "none",
                            stroke: "context-stroke",
                            strokeWidth: 1,
                        }}
                        d="M0 4v-8"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="barraAmarilla2"
                    refX={0}
                    refY={0}
                    orient="auto"
                    markerWidth={0.41}
                    markerHeight={3}
                    viewBox="0 0 1 8"
                    preserveAspectRatio="none"
                    fill="#C1C134"
                    stroke="#C1C134"
                >
                    <path
                        style={{
                            fill: "none",
                            stroke: "context-stroke",
                            strokeWidth: 1,
                        }}
                        d="M0 4v-8"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cuadradoAzul2"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inte52HTBcolor}
                    stroke="#33BBC2"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cruzAzul2"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inte52HTBcolor}
                    stroke="#33BBC2"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="m-3.5 4.5 9-9m0 9-9-9"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="rectanguloAmarillo2"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={6.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="none"
                    stroke="#C1C134"
                    fill="#none"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "none",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>
            </defs>
            <g
                style={{
                    display: "inline",
                }}
            >
                <path
                    style={{
                        fill: "#34bac1",
                        fillOpacity: 1,
                        stroke: "#34bac1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#flechaAzul2)",
                        markerEnd: "url(#barraAzul2)",
                        paintOrder: "normal",
                        fillRule: "nonzero",
                    }}
                    d="M96.044 38.2v5.514"
                />
                <path
                    id='llave2'
                    style={{
                        fill: "none",
                        stroke: secc89Lcolor,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89L}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34b9c1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAzul2)",
                        markerEnd: inte52HTB,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M96.055 45.99v2.7"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34b9c1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M96.055 49.81v2.14"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34b9c1",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M97.143 52.97a1.081 1.087 0 0 1-1.074 1.095 1.081 1.087 0 0 1-1.088-1.08 1.081 1.087 0 0 1 1.074-1.094 1.081 1.087 0 0 1 1.088 1.08"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M97.144 54.193a1.081 1.087 0 0 1-1.075 1.094 1.081 1.087 0 0 1-1.088-1.08 1.081 1.087 0 0 1 1.074-1.094 1.081 1.087 0 0 1 1.089 1.08"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M96.069 55.319v7.513"
                />
                <path
                    id='llave4'
                    style={{
                        fill: "none",
                        stroke: secc89H06color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89H06}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo2)",
                        markerEnd: inteH06,
                        paintOrder: "normal",
                    }}
                    d="M96.062 65.307v3.864"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M96.062 70.104v2.14"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M78.214 72.263h31.584"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M82.625 72.377v1.649"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: inteH07,
                        paintOrder: "normal",
                    }}
                    d="M103.017 72.38v1.985"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M103.006 75.548v2.502"
                />
                <path
                    id='llave8'
                    style={{
                        fill: "none",
                        stroke: secc89H07color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89H07}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo2)",
                        markerEnd: "url(#flechaAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M103.04 80.061v5.114"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M103.087 82.014h1.241"
                />
                <path
                    id='llave9'
                    style={{
                        fill: "none",
                        stroke: secc57H07color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H07}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo2)",
                        markerEnd: "url(#flechaAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M106.574 82.019h1.584"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M96.15 60.318h1.24"
                />
                <path
                    id='llave3'
                    style={{
                        fill: "none",
                        stroke: secc57H06color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H06}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo2)",
                        markerEnd: "url(#flechaAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M99.694 60.306h1.584"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34b9c1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAzul2)",
                        paintOrder: "normal",
                    }}
                    d="M96.19 41.211h1.241"
                />
                <path
                    id='llave1'
                    style={{
                        fill: "none",
                        stroke: secc89PTLcolor,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89PTL}
                />
                <path
                    style={{
                        fill: "#33bbc2",
                        stroke: "#34b9c1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAzul2)",
                        markerEnd: "url(#flechaAzul2)",
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M99.702 41.216h1.584"
                />
                <path
                    id='llave5'
                    style={{
                        fill: "none",
                        stroke: secc89H05color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89H05}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo2)",
                        markerEnd: "url(#rectanguloAmarillo2)",
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M82.624 76.047v2.502"
                />

                <path
                    style={{
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M82.622 77.641v4.405"
                />
                <path
                    style={{
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M82.622 80.641v4.405"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerEnd: "url(#flechaAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M82.436 84.861h-5.952"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M82.67 82.25h1.24"
                />
                <path
                    id='llave7'
                    style={{
                        fill: "none",
                        stroke: secc57H05Bcolor,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H05B}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo2)",
                        markerEnd: "url(#flechaAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M86.123 82.24H88"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla2)",
                        paintOrder: "normal",
                    }}
                    d="M82.754 76.82h1.24"
                />
                <path
                    id='llave6'
                    style={{
                        fill: "none",
                        stroke: secc57H05Acolor,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H05A}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo2)",
                        paintOrder: "normal",
                    }}
                    d="M86.21 76.812h1.225"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M87.248 82.079v-5.437"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={86.205}
                    y={40}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={86.205}
                        y={39.5}
                    >
                        {B01}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={86.205}
                        y={41}
                    >
                        {B02}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={86.205}
                        y={42.5}
                    >
                        {B03}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={86.205}
                        y={44}
                    >
                        {B04}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={89.412}
                    y={40}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={89.412}
                        y={39.5}
                    >
                        {"kV"}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={89.412}
                        y={41}
                    >
                        {"A"}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={89.412}
                        y={42.5}
                    >
                        {"MW"}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={89.412}
                        y={44}
                    >
                        {"MVAr"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bac1",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={86.277}
                    y={53.391}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bac1",
                            fillOpacity: 1,
                        }}
                        x={86.277}
                        y={53.391}
                    >
                        {"TOMA"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={90.165}
                    y={53.381}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={90.165}
                        y={53.391}
                    >
                        {toma}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={82.265}
                    y={51.254}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={82.421}
                        y={51.254}
                    >
                        {"REG EN LOCAL"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={82}
                    y={52.313}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={82}
                        y={52.313}
                    >
                        {"AUTO/MANUAL"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={83.5}
                    y={49.85}
                >
                    <tspan
                        style={{
                            fill: "#33bbc2",
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fillOpacity: 1,
                        }}
                        x={83.5}
                        y={49.85}
                    >
                        {"REGULADOR"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        fillOpacity: 1,
                        stroke: "#c1c134",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    x={87}
                    y={65}
                >
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={87}
                        y={65}
                    >
                        {B05}
                    </tspan>
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={87}
                        y={66.5}
                    >
                        {B06}
                    </tspan>
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={87}
                        y={68}
                    >
                        {B07}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        fillOpacity: 1,
                        stroke: "#c1c134",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    x={91.506}
                    y={65}
                >
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={91.506}
                        y={65}
                    >
                        {"A"}
                    </tspan>
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={91.506}
                        y={66.5}
                    >
                        {"MW"}
                    </tspan>
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={91.506}
                        y={68}
                    >
                        {"MVAR"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#32bac2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={114.287}
                    y={35.018}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#32bac2",
                            fillOpacity: 1,
                        }}
                        x={114.287}
                        y={35.018}
                    >
                        {"89PTL-B"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={112.159}
                    y={39.021}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={112.159}
                        y={39.021}
                    >
                        {"89L-HTB"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={112.064}
                    y={43.508}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={112.064}
                        y={43.508}
                    >
                        {"52HTB"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={116.684}
                    y={45.118}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={116.7}
                        y={45.25}
                    >
                        {"POSICION EN LOCAL"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={114.098}
                    y={51.517}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={114.098}
                        y={51.517}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={112.292}
                    y={55.63}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={112.292}
                        y={55.63}
                    >
                        {"89"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={111.503}
                    y={60.793}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={111.503}
                        y={60.793}
                    >
                        {"52"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={108.537}
                    y={60.778}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={108.537}
                        y={60.778}
                    >
                        {estadointeH06}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={96.158}
                    y={64.503}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={96.158}
                        y={64.503}
                    >
                        {"89"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={98.155}
                    y={65.869}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={98.155}
                        y={65.869}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={98.25}
                    y={70.586}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={98.25}
                        y={70.586}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={119.661}
                    y={65.308}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={119.661}
                        y={65.308}
                    >
                        {"52"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={119.775}
                    y={67.818}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={119.775}
                        y={67.818}
                    >
                        {"89"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={116.486}
                    y={65.351}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={116.486}
                        y={65.351}
                    >
                        {estadointeH07}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={121.563}
                    y={70.471}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={121.563}
                        y={70.471}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={90.101}
                    y={62.504}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={122}
                        y={62.523}
                    >
                        {"BARRA 2"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={125.086}
                    y={62.544}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={93.5}
                        y={62.523}
                    >
                        {"kV"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={124.398}
                    y={72.889}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={124.5}
                        y={72.889}
                    >
                        {B09}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={125.745}
                    y={72.892}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={128.745}
                        y={72.892}
                    >
                        {"A"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#000",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    x={87.5}
                    y={73}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                        }}
                        x={86.5}
                        y={73}
                    >
                        {"HACIA CELDA H01"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: PT_T2_UCP_IDF50BF,
                        stroke: "#c1c134",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.7}
                    height={0.7}
                    x={98.863}
                    y={69.323}
                    ry={0}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={115.2}
                    y={60.9}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={115.2}
                        y={60.9}
                    >
                        {"50BF"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: "none",
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.7}
                    height={0.7}
                    x={101.282}
                    y={45.724}
                    ry={0}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={118}
                    y={40.4}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={118}
                        y={40.4}
                    >
                        {"49"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: PT_T2_UCP_IDF86,
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.7}
                    height={0.7}
                    x={101.281}
                    y={46.8}
                    ry={0}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={118}
                    y={41.4}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={118}
                        y={41.4}
                    >
                        {"86"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: H0650BF,
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.7}
                    height={0.7}
                    x={101.276}
                    y={48}
                    ry={0}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={118}
                    y={42.4}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={118}
                        y={42.4}
                    >
                        {"50BF"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: "none",
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={9.808}
                    height={1.5}
                    x={81.5}
                    y={48.756}
                    ry={0}
                />
                <rect
                    style={{
                        fill: "none",
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={9.808}
                    height={4.022}
                    x={81.5}
                    y={50.259}
                    ry={0}
                />
                <rect
                    style={{
                        fill: "#33bbc2",
                        fillOpacity: 1,
                        stroke: "#33bbc2",
                        strokeWidth: 0.02,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.567}
                    height={0.576}
                    x={90.069}
                    y={51.734}
                    ry={0}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34bac1",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M90.628 51.017a.3.302 0 0 1-.298.304.3.302 0 0 1-.303-.3.3.302 0 0 1 .299-.305.3.302 0 0 1 .302.3"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={105.231}
                    y={31.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={105.231}
                        y={31.5}
                    >
                        {"TRAFO 2 PLANTA"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        fillOpacity: 1,
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    x={106.263}
                    y={32.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            fill: "#33bbc2",
                            fillOpacity: 1,
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                        }}
                        x={106.263}
                        y={32.5}
                    >
                        {"   B SET PLANTA"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={113.2}
                    y={31.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={113.2}
                        y={31.5}
                    >
                        {"45"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={115.5}
                    y={31.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={115.5}
                        y={31.5}
                    >
                        {"KV"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={121}
                    y={62.523}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={90.2}
                        y={62.523}
                    >
                        {B08}
                    </tspan>
                </text>

                <rect
                    width={4}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={93}
                    y={76.5}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={94}
                    y={77.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={94}
                        y={77.5}
                    >
                        {"H05"}
                    </tspan>
                </text>

                <rect
                    width={4}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={119}
                    y={51.9}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={120}
                    y={50}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={120}
                        y={53}
                    >
                        {"H06"}
                    </tspan>
                </text>

                <rect
                    width={4}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={116.3}
                    y={76.5}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={117.4}
                    y={77.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={117.4}
                        y={77.5}
                    >
                        {"H07"}
                    </tspan>
                </text>

                <path
                    style={{
                        fill: estado52HTB,
                        stroke: "#34bac1",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M101.29 51.641a.3.302 0 0 1-.299.305.3.302 0 0 1-.303-.3.3.302 0 0 1 .3-.305.3.302 0 0 1 .302.3"
                />

<rect
                    width={5}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={108}
                    y={29}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={108.5}
                    y={30}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={108.5}
                        y={30}
                    >
                        {"LIN-TRF2"}
                    </tspan>
                </text>

            </g>
        </svg>
    )
}

export default Subestacion2